export default {
  SET_ITEMS(state, payload) {
    state.users = payload
  },

}
